import useEvent from '@lyearn/core/hooks/useEvent';
import LikertScale from '@/modules/user-survey/components/LikertScale';
import useQuestionPlayerResponse from '@/modules/user-survey/hooks/useQuestionPlayerResponse';
import QuestionPlayerContainer from '@/modules/user-survey/questions/components/QuestionPlayerContainer';
import { QuestionPlayerProps } from '@/modules/user-survey/questions/types';
import { ResourceResponseTypeEnum } from '@/types/schema';

import { getCustomRatingLabels } from '../../utils';

const LikertQuestionPlayer = (props: QuestionPlayerProps) => {
  const {
    variant,
    question,
    userSurveyQuestionSettings,
    error,
    useRichTextForComment,
    response,
    onChange,
    commentTitle,
    disabled,
    requireComments,
  } = props;
  const actions = useQuestionPlayerResponse({ response, onChange });

  const onValueChange = useEvent((likertResponse: number) => {
    if (disabled) {
      return;
    }

    actions.onQuestionResponseChange({
      responseType: ResourceResponseTypeEnum.Likert,
      likertResponse,
    });
  });

  return (
    <QuestionPlayerContainer
      commentTitle={commentTitle}
      disabled={disabled}
      error={error}
      post={response?.post}
      question={question}
      requireComments={requireComments}
      useRichTextForComment={useRichTextForComment}
      userSurveyQuestionSettings={userSurveyQuestionSettings}
      variant={variant}
      onPostChange={actions.onPostChange}>
      <LikertScale
        className={variant === 'form' ? 'mt-16' : 'mt-32'}
        ratingLabels={getCustomRatingLabels(question)}
        size={variant === 'form' ? 'small' : 'large'}
        value={response?.questionSurveyResponse?.likertResponse}
        onChange={onValueChange}
      />
    </QuestionPlayerContainer>
  );
};

export default LikertQuestionPlayer;
